(function () {
  var CURRENT_GIFT_HANDLES = ['palas-gingham-tote-bag-red-turquoise-copy'];
  var AUTO_GIFT_HANDLES = ['mini-sol-charm'];
  var AUTO_GIFT_VARIANT_IDS = [49737197191515];
  var RETIRED_INSTANT_GIFT_HANDLES = ['roma-earrings-silver'];
  var AUTO_GIFT_MIN_SUBTOTAL = Number(window.PalasAutomaticFreeGiftMinimumSubtotal || 50);
  var GIFT_HREF_PATTERN = /\/products\/gift-/i;
  var FREE_PRICE_PATTERN = /(^|[^0-9])(0([,.]00)?\s*€|€\s*0([,.]00)?|offert|gratuit|free)([^0-9]|$)/i;
  var GIFT_TEXT_PATTERN = /\b(gift\s*-|cadeau offert|charm offert|cabas offert)\b/i;
  var thresholdCheckInProgress = false;
  var thresholdCheckPromise = null;
  var thresholdCheckTimer = null;

  function hrefMatchesCurrentGift(href) {
    return CURRENT_GIFT_HANDLES.some(function (handle) {
      return href.indexOf('/products/' + handle) !== -1;
    });
  }

  function itemLooksFree(item) {
    var priceText = Array.prototype.map.call(item.querySelectorAll('.cart__price, .cart__discount'), function (node) {
      return node.textContent || '';
    }).join(' ');

    return FREE_PRICE_PATTERN.test(priceText);
  }

  function isFreeGiftItem(item) {
    if (!item) return false;

    if (item.getAttribute('data-palas-free-gift') === 'true') return true;

    var giftLink = item.querySelector('a[href*="/products/gift-"]');
    if (giftLink) return true;

    var currentGiftLink = Array.prototype.some.call(item.querySelectorAll('a[href]'), function (link) {
      return hrefMatchesCurrentGift(link.getAttribute('href') || '');
    });
    if (currentGiftLink && itemLooksFree(item)) return true;

    var name = item.querySelector('.cart__item-name');
    if (name && GIFT_TEXT_PATTERN.test(name.textContent || '')) return true;

    return false;
  }

  function disableGiftLinks(item) {
    var links = item.querySelectorAll('a[href]');

    links.forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var text = link.textContent || '';

      if (!GIFT_HREF_PATTERN.test(href) && !hrefMatchesCurrentGift(href) && !GIFT_TEXT_PATTERN.test(text)) return;

      link.dataset.palasDisabledHref = href;
      link.removeAttribute('href');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
      link.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
      });
    });
  }

  function protectGiftItems(root) {
    var scope = root || document;
    var items = scope.querySelectorAll ? scope.querySelectorAll('.cart__item') : [];

    items.forEach(function (item) {
      if (!isFreeGiftItem(item)) return;

      item.classList.add('free-gift-item', 'palas-free-gift-item');
      item.setAttribute('data-palas-free-gift', 'true');
      disableGiftLinks(item);
    });
  }

  function isFreeGiftProperty(properties, key) {
    return properties && properties[key] === 'true';
  }

  function isAnyFreeGiftCartItem(item) {
    return item && item.properties && (
      isFreeGiftProperty(item.properties, '_free_gift') ||
      isFreeGiftProperty(item.properties, '_free_gift_auto') ||
      isFreeGiftProperty(item.properties, '_free_gift_threshold') ||
      isFreeGiftProperty(item.properties, '_free_gift_discount_code')
    );
  }

  function findAutomaticGift(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    return cart.items.find(function (item) {
      if (isFreeGiftProperty(item.properties, '_free_gift_auto')) return true;

      var variantId = Number(item.variant_id || item.id);
      var handle = item.handle || '';
      var isTemporaryGiftProduct = AUTO_GIFT_VARIANT_IDS.indexOf(variantId) !== -1 ||
        AUTO_GIFT_HANDLES.indexOf(handle) !== -1;

      return isTemporaryGiftProduct && (
        isFreeGiftProperty(item.properties, '_free_gift') ||
        Number(item.final_line_price) === 0 ||
        Number(item.final_price) === 0 ||
        Number(item.price) === 0
      );
    }) || null;
  }

  function findRetiredInstantGift(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    return cart.items.find(function (item) {
      var handle = item.handle || '';
      var isRetiredProduct = RETIRED_INSTANT_GIFT_HANDLES.indexOf(handle) !== -1;
      var isInstantGift = isFreeGiftProperty(item.properties, '_free_gift') ||
        isFreeGiftProperty(item.properties, '_free_gift_auto') ||
        isFreeGiftProperty(item.properties, '_free_gift_discount_code');

      return isRetiredProduct &&
        !isFreeGiftProperty(item.properties, '_free_gift_threshold') &&
        isInstantGift;
    }) || null;
  }

  function isAutomaticGiftPromotionActive() {
    var config = window.PalasFreeGift;
    if (!config || !config.enabled) return false;
    if (!config.startDate || !config.endDate) return true;

    var now = new Date();
    return now >= new Date(config.startDate) && now <= new Date(config.endDate);
  }

  function automaticGiftVariantId() {
    var configVariantId = window.PalasFreeGift &&
      window.PalasFreeGift.product &&
      window.PalasFreeGift.product.variantId;

    return Number(configVariantId || AUTO_GIFT_VARIANT_IDS[0]);
  }

  function regularCartSubtotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (sum, item) {
      if (isAnyFreeGiftCartItem(item)) return sum;
      return sum + (Number(item.line_price) || 0);
    }, 0) / 100;
  }

  async function removeCartItem(item) {
    if (!item || !item.key) return false;
    var response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    });
    return response.ok;
  }

  async function addAutomaticGift() {
    var variantId = automaticGiftVariantId();
    if (!variantId) return false;

    var response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { _free_gift: 'true', _free_gift_auto: 'true' }
        }]
      })
    });

    return response.ok;
  }

  function triggerCartRebuild() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  async function enforceAutomaticGiftThreshold() {
    if (!AUTO_GIFT_MIN_SUBTOTAL || AUTO_GIFT_MIN_SUBTOTAL <= 0) return;
    if (thresholdCheckInProgress) return thresholdCheckPromise;

    thresholdCheckInProgress = true;
    thresholdCheckPromise = window.PalasCartMutations.run(async function () {
      var controller = new AbortController();
      var readTimeout;
      var cart;
      try {
        cart = await Promise.race([
          fetch('/cart.js', {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            signal: controller.signal
          }).then(function(response) {
            if (!response.ok) throw new Error('Cart read failed');
            return response.json();
          }),
          new Promise(function(resolve, reject) {
            readTimeout = setTimeout(function() {
              controller.abort();
              reject(new Error('Cart read timed out'));
            }, 4000);
          })
        ]);
      } finally {
        clearTimeout(readTimeout);
      }
      var retiredInstantGift = findRetiredInstantGift(cart);
      if (retiredInstantGift) {
        var retiredGiftRemoved = await removeCartItem(retiredInstantGift);
        if (retiredGiftRemoved) {
          triggerCartRebuild();
        }
        return;
      }

      var automaticGift = findAutomaticGift(cart);
      var subtotal = regularCartSubtotal(cart);

      if (!isAutomaticGiftPromotionActive()) {
        if (automaticGift) {
          var inactiveGiftRemoved = await removeCartItem(automaticGift);
          if (inactiveGiftRemoved) {
            triggerCartRebuild();
          }
        }
        return;
      }

      if (subtotal >= AUTO_GIFT_MIN_SUBTOTAL && !automaticGift) {
        var added = await addAutomaticGift();
        if (added) {
          triggerCartRebuild();
        }
        return;
      }

      if (subtotal < AUTO_GIFT_MIN_SUBTOTAL && automaticGift) {
        var removed = await removeCartItem(automaticGift);
        if (removed) {
          triggerCartRebuild();
        }
      }
    })
      .catch(function () {
        // Best-effort guard: never block the cart if Shopify Ajax is unavailable.
      })
      .finally(function () {
        thresholdCheckInProgress = false;
        thresholdCheckPromise = null;
      });
    // Concurrent callers share the handled promise, including queue expiry.
    return thresholdCheckPromise;
  }

  function scheduleAutomaticGiftThresholdCheck(delay) {
    var wait = typeof delay === 'number' ? delay : 120;
    clearTimeout(thresholdCheckTimer);
    thresholdCheckTimer = setTimeout(enforceAutomaticGiftThreshold, wait);
  }

  function initGiftGuard() {
    protectGiftItems(document);
    scheduleAutomaticGiftThresholdCheck(80);

    var drawer = document.getElementById('CartDrawer') || document.body;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches('.cart__item')) {
            protectGiftItems(node.parentNode || node);
          } else {
            protectGiftItems(node);
          }
          scheduleAutomaticGiftThresholdCheck(120);
        });
      });
    });

    observer.observe(drawer, { childList: true, subtree: true });

    document.addEventListener('cart:updated', function () {
      scheduleAutomaticGiftThresholdCheck(0);
    });
    document.addEventListener('cart:refresh', function () {
      scheduleAutomaticGiftThresholdCheck(0);
    });
    document.addEventListener('theme:cart:change', function () {
      scheduleAutomaticGiftThresholdCheck(0);
    });
    document.addEventListener('ajaxProduct:added', function () {
      scheduleAutomaticGiftThresholdCheck(0);
    });
    document.addEventListener('product-form:cart:update', function () {
      scheduleAutomaticGiftThresholdCheck(0);
    });
    document.addEventListener('product-form:submit:success', function () {
      scheduleAutomaticGiftThresholdCheck(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftGuard);
  } else {
    initGiftGuard();
  }

  window.PalasSyncAutomaticFreeGift = enforceAutomaticGiftThreshold;
})();
